import { createSlice } from '@reduxjs/toolkit'

export interface LandingState {
  isLoading: boolean
  subscribeResponseMessage: string | null
  isSubscribeSuccess: boolean | null
  isSendContactMessageSuccess: boolean
}

const initialState: LandingState = {
  isLoading: false,
  subscribeResponseMessage: null,
  isSubscribeSuccess: null,
  isSendContactMessageSuccess: false,
}

const landingSlice = createSlice({
  name: 'landing',
  initialState,
  reducers: {
    apiRequest: (state) => {
      state.isLoading = true
      state.isSendContactMessageSuccess = false
      state.isSubscribeSuccess = null
      state.subscribeResponseMessage = null
    },
    apiFailure: (state) => {
      state.isLoading = false
      state.isSendContactMessageSuccess = false
      state.isSubscribeSuccess = null
      state.subscribeResponseMessage = null
    },
    sendContactMessage(state) {
      state.isLoading = false
      state.isSendContactMessageSuccess = true
    },
    subscribe(state, action) {
      state.isLoading = false
      state.isSubscribeSuccess = action.payload.success
      state.subscribeResponseMessage = action.payload.message
    },
  },
})

export const { apiRequest, apiFailure, sendContactMessage, subscribe } =
  landingSlice.actions
export default landingSlice.reducer
